import { ComboBox, TextInput } from '@components';
import { banks } from '@utils';
import { Field, useFormikContext } from 'formik';
import React from 'react';

export const DadosBancarios = () => {
  const { setFieldValue } = useFormikContext();

  return (
    <div className="card">
      <div className="card-body row">
        <div className="col-12 col-lg-6">
          <Field
            name="banco"
            className="mb-3"
            component={ComboBox}
            label="Banco"
            onChange={() => {
              setFieldValue('agencia', '');
              setFieldValue('conta', '');
              setFieldValue('digito', '');
            }}
            options={banks.map((s) => {
              return {
                value: s.codigo,
                label: `${s.codigo} - ${s.banco}`,
              };
            })}
          />
        </div>
        <div className="col-4 col-lg-1">
          <Field
            type="text"
            name="agencia"
            noPadding
            component={TextInput}
            label="Agência"
          />
        </div>
        <div className="col-5 col-lg-2 px-0">
          <Field name="conta" type="text" component={TextInput} label="Conta" />
        </div>
        <div className="col-3 col-lg-1">
          <Field
            name="digito"
            type="text"
            noPadding
            component={TextInput}
            label="Digito"
          />
        </div>
      </div>
    </div>
  );
};
